export const arr = [...Array(20).keys()];
arr.push(116 - 1);
arr.push(270 - 1);
arr.push(680 - 1);

export const parisZipOptions = arr.map(i => {
  const str = (75000 + i + 1).toString();
  return {label: str, value: str};
});

export const parisCityOptions = [
  // 1ere zone
  { label: "Zone 1 - Paris", value: "Paris"},
  // { label: "Paris", value: "Paris"},
]

export const zone2CityOptions = [
  // 2eme zone
  { label: "Zone 2 - Neuilly-sur-Seine", value: "Neuilly-sur-Seine"},
  { label: "Zone 2 - Levallois-Perret", value: "Levallois-Perret"},
  { label: "Zone 2 - Clichy", value: "Clichy"},
  { label: "Zone 2 - Saint-Ouen-sur-Seine", value: "Saint-Ouen-sur-Seine"},
  { label: "Zone 2 - Saint-Denis", value: "Saint-Denis"},
  { label: "Zone 2 - Aubervilliers", value: "Aubervilliers"},
  { label: "Zone 2 - Pantin", value: "Pantin"},
  { label: "Zone 2 - Le-Pré-Saint-Gervais", value: "Le-Pré-Saint-Gervais"},
  { label: "Zone 2 - Les-Lilas", value: "Les-Lilas"},
  { label: "Zone 2 - Bagnolet", value: "Bagnolet"},
  { label: "Zone 2 - Montreuil", value: "Montreuil"},
]

export const zone3CityOptions = [
  // 3eme zone
  { label: "Zone 3 - Boulogne-Bilancourt", value: "Boulogne-Bilancourt"},
  { label: "Zone 3 - Puteaux", value: "Puteaux"}, 
  { label: "Zone 3 - Courbevoie", value: "Courbevoie"},
  { label: "Zone 3 - Asnières-sur-Seine", value: "Asnières-sur-Seine"},
  { label: "Zone 3 - Nanterre (la défense)", value: "Nanterre"},
  { label: "Zone 3 - La-Garenne-Colombes", value: "La-Garenne-Colombes"},
  { label: "Zone 3 - Bois-Colombes", value: "Bois-Colombes"},
  // { label: "Colombes", value: "Colombes"},
]

export const zone2BCityOptions = [
  { label: "Zone 2B - Issy-les-Moulineaux", value: "Issy-les-Moulineaux"},
  { label: "Zone 2B - Vanves", value: "Vanves"},
  { label: "Zone 2B - Malakoff", value: "Malakoff"},
  { label: "Zone 2B - Montrouge", value: "Montrouge"},
  { label: "Zone 2B - Gentilly", value: "Gentilly"},
  { label: "Zone 2B - Le-Kremlin-Bicêtre", value: "Le-Kremlin-Bicêtre"},
  { label: "Zone 2B - Ivry-sur-Seine", value: "Ivry-sur-Seine"},
  { label: "Zone 2B - Charenton-le-Pont", value: "Charenton-le-Pont"},
  { label: "Zone 2B - Saint-Mandé", value: "Saint-Mandé"},
  { label: "Zone 2B - Vincennes", value: "Vincennes"},
]

export const offZoneCityOptions = [
  { label: "Hors Zone - Colombes", value: "Colombes", retailerIds : ["dose.paris", "DRAFT"]},
  { label: "Hors Zone - Saint-Cloud", value: "Saint-Cloud", retailerIds : ["dose.paris", "DRAFT"]},
  { label: "Hors Zone - Rueil-Malmaison", value: "Rueil-Malmaison", retailerIds : ["dose.paris", "DRAFT"]},
]

export const cityZips = {
  "Paris": "All75",
  "Boulogne-Bilancourt": "92100",
  "Neuilly-sur-Seine": "92200",
  "Levallois-Perret": "92300",
  "Clichy": "92110",
  // "Colombes": "92700",
  "Courbevoie": "92400",
  "Nanterre": "92000",
  "Saint-Ouen-sur-Seine": "93400",
  "Saint-Denis": "93200",
  "Aubervilliers": "93300",
  "Pantin": "93500",
  "Le-Pré-Saint-Gervais" : "93310",
  "Les-Lilas": "93260",
  "Bagnolet": "93170",
  "Montreuil": "93100",
  "Puteaux": "92800",
  "Asnières-sur-Seine": "92600",
  "La-Garenne-Colombes": "92250",
  "Bois-Colombes": "92270",

  "Issy-les-Moulineaux": "92130",
  "Vanves": "92170",
  "Malakoff": "92240",
  "Montrouge": "92120",
  "Gentilly": "94250",
  "Le-Kremlin-Bicêtre": "94270",
  "Ivry-sur-Seine": "94200",
  "Charenton-le-Pont": "94220",
  "Saint-Mandé": "94160",
  "Vincennes": "94300",

  "Colombes": "92700",
  "Saint-Cloud": "92210",
  "Rueil-Malmaison": "92500",
}

export const weightOptions = [
  { value: "0" },
  { value: "2" },
  { value: "4" },
  { value: "6" },
  { value: "8" },
  { value: "10" },
  { value: "20" },
  { value: "30" },
  { value: "40" },
  { value: "50" },
  { value: "60" },
  { value: "70" },
  { value: "80" },
  { value: "90" },
  { value: "100" },
  { value: "110" },
  { value: "120" },
  { value: "130" },
  { value: "140" },
  { value: "150" },
  { value: "160" },
  { value: "170" },
  { value: "180" },
  { value: "190" },
  { value: "200" },
  { value: "210" },
  { value: "220" },
  { value: "230" },
  { value: "240" },
  { value: "250" },
  { value: "260" },
  { value: "270" },
  { value: "280" },
  { value: "290" },
  { value: "300" },
  { value: "310" },
  { value: "320" },
  { value: "330" },
  { value: "340" },
  { value: "350" },
  { value: "360" },
  { value: "370" },
  { value: "380" },
  { value: "390" },
  { value: "400" }, 
  { value: "410" },
  { value: "420" },
  { value: "430" },
  { value: "440" },
  { value: "450" }, 
]

for(let weightOption of weightOptions) {
  const w = parseInt(weightOption.value);
  weightOption.label = `${w} Kg - ${w*5} L`;
  if(w > 90) {
    weightOption.label += ` (${Math.ceil(w/90)})`;
  }
}

export const temperatureRangeOptions = [
  { label: "Ambiante", value: "10-30"},
  { label: "0°C-4°C", value: "0-4"}
]

// TODO rename this as timeWindowAllOptions.
export const allStartTimeOptions = [
  { tsType: "1", label: "07h00 - 08h00", value: "7" },
  { tsType: "1", label: "07h15 - 08h15", value: "7.25" },
  { tsType: "1", label: "07h30 - 08h30", value: "7.5" },
  { tsType: "1", label: "07h45 - 08h45", value: "7.75" },
  { tsType: "1", label: "08h00 - 09h00", value: "8" },
  { tsType: "1", label: "08h15 - 09h15", value: "8.25" },
  { tsType: "1", label: "08h30 - 09h30", value: "8.5" },
  { tsType: "1", label: "08h45 - 09h45", value: "8.75" },
  { tsType: "1", label: "09h00 - 10h00", value: "9" },
  { tsType: "1", label: "09h15 - 10h15", value: "9.25" },
  { tsType: "1", label: "09h30 - 10h30", value: "9.5" },
  { tsType: "1", label: "09h45 - 10h45", value: "9.75" },
  { tsType: "1", label: "10h00 - 11h00", value: "10" },
  { tsType: "1", label: "10h15 - 11h15", value: "10.25" },
  { tsType: "1", label: "10h30 - 11h30", value: "10.5" },
  { tsType: "1", label: "10h45 - 11h45", value: "10.75" },
  { tsType: "1", label: "11h00 - 12h00", value: "11" },
  { tsType: "1", label: "11h15 - 12h15", value: "11.25" },
  { tsType: "1", label: "11h30 - 12h30", value: "11.5" },
  { tsType: "1", label: "11h45 - 12h45", value: "11.75" },
  { tsType: "1", label: "12h00 - 13h00", value: "12" },
  { tsType: "1", label: "12h15 - 13h15", value: "12.25" },
  { tsType: "1", label: "12h30 - 13h30", value: "12.5" },
  { tsType: "1", label: "12h45 - 13h45", value: "12.75" },
  { tsType: "1", label: "14h00 - 15h00", value: "14" },
  { tsType: "1", label: "14h15 - 15h15", value: "14.25" },
  { tsType: "1", label: "14h30 - 15h30", value: "14.5" },
  { tsType: "1", label: "14h45 - 15h45", value: "14.75" },
  { tsType: "1", label: "15h00 - 16h00", value: "15" },
  // { tsType: "1", label: "15h15 - 16h15", value: "15.25" },
  // { tsType: "1", label: "15h30 - 16h30", value: "15.5" },
  // { tsType: "1", label: "15h45 - 16h45", value: "15.75" },
  // { tsType: "1", label: "16h00 - 17h00", value: "16" },
  // { tsType: "1", label: "16h15 - 17h15", value: "16.25" },
  // { tsType: "1", label: "16h30 - 17h30", value: "16.5" },
  // { tsType: "1", label: "16h45 - 17h45", value: "16.75" },
  // { tsType: "1", label: "17h00 - 18h00", value: "17" },
  { tsType: "0", label: "07h00 - 08h00", value: "7" },
  { tsType: "0", label: "07h15 - 08h15", value: "7.25" },
  { tsType: "0", label: "07h30 - 08h30", value: "7.5" },
  { tsType: "0", label: "07h45 - 08h45", value: "7.75" },
  { tsType: "0", label: "08h00 - 09h00", value: "8" },
  { tsType: "0", label: "08h15 - 09h15", value: "8.25" },
  { tsType: "0", label: "08h30 - 09h30", value: "8.5" },
  { tsType: "0", label: "08h45 - 09h45", value: "8.75" },
  { tsType: "0", label: "09h00 - 10h00", value: "9" },
  { tsType: "0", label: "09h15 - 10h15", value: "9.25" },
  { tsType: "0", label: "09h30 - 10h30", value: "9.5" },
  { tsType: "0", label: "09h45 - 10h45", value: "9.75" },
  { tsType: "0", label: "10h00 - 11h00", value: "10" },
  { tsType: "0", label: "10h15 - 11h15", value: "10.25" },
  { tsType: "0", label: "10h30 - 11h30", value: "10.5" },
  { tsType: "0", label: "10h45 - 11h45", value: "10.75" },
  { tsType: "0", label: "11h00 - 12h00", value: "11" },
  { tsType: "0", label: "11h15 - 12h15", value: "11.25" },
  { tsType: "0", label: "11h30 - 12h30", value: "11.5" },
  { tsType: "0", label: "11h45 - 12h45", value: "11.75" },
  { tsType: "0", label: "12h00 - 13h00", value: "12" },
  { tsType: "0", label: "12h15 - 13h15", value: "12.25" },
  { tsType: "0", label: "12h30 - 13h30", value: "12.5" },
  { tsType: "0", label: "12h45 - 13h45", value: "12.75" },
  { tsType: "0", label: "14h00 - 15h00", value: "14" },
  { tsType: "0", label: "14h15 - 15h15", value: "14.25" },
  { tsType: "0", label: "14h30 - 15h30", value: "14.5" },
  { tsType: "0", label: "14h45 - 15h45", value: "14.75" },
  { tsType: "0", label: "15h00 - 16h00", value: "15" },
  // { tsType: "0", label: "15h15 - 16h15", value: "15.25" },
  // { tsType: "0", label: "15h30 - 16h30", value: "15.5" },
  // { tsType: "0", label: "15h45 - 16h45", value: "15.75" },
  // { tsType: "0", label: "16h00 - 17h00", value: "16" },
  // { tsType: "0", label: "16h15 - 17h15", value: "16.25" },
  // { tsType: "0", label: "16h30 - 17h30", value: "16.5" },
  // { tsType: "0", label: "16h45 - 17h45", value: "16.75" },
  // { tsType: "0", label: "17h00 - 18h00", value: "17" },
  { tsType: "2", label: "08h00 - 10h00", value: "8" },
  { tsType: "2", label: "08h15 - 10h15", value: "8.25" },
  { tsType: "2", label: "08h30 - 10h30", value: "8.5" },
  { tsType: "2", label: "08h45 - 10h45", value: "8.75" },
  { tsType: "2", label: "09h00 - 11h00", value: "9" },
  { tsType: "2", label: "09h15 - 11h15", value: "9.25" },
  { tsType: "2", label: "09h30 - 11h30", value: "9.5" },
  { tsType: "2", label: "09h45 - 11h45", value: "9.75" },
  { tsType: "2", label: "10h00 - 12h00", value: "10" },
  { tsType: "2", label: "10h15 - 12h15", value: "10.25" },
  { tsType: "2", label: "10h30 - 12h30", value: "10.5" },
  { tsType: "2", label: "10h45 - 12h45", value: "10.75" },
  { tsType: "2", label: "11h00 - 13h00", value: "11" },
  { tsType: "2", label: "11h15 - 13h15", value: "11.25" },
  { tsType: "2", label: "11h30 - 13h30", value: "11.5" },
  { tsType: "2", label: "11h45 - 13h45", value: "11.75" },
  { tsType: "2", label: "14h00 - 16h00", value: "14" },
  { tsType: "2", label: "14h15 - 16h15", value: "14.25" },
  { tsType: "2", label: "14h30 - 16h30", value: "14.5" },
  { tsType: "2", label: "14h45 - 16h45", value: "14.75" },
  { tsType: "2", label: "15h00 - 17h00", value: "15" },
  // { tsType: "2", label: "15h15 - 17h15", value: "15.25" },
  // { tsType: "2", label: "15h30 - 17h30", value: "15.5" },
  // { tsType: "2", label: "15h45 - 17h45", value: "15.75" },
  // { tsType: "2", label: "16h00 - 18h00", value: "16" },
  { tsType: "3", label: "08h00 - 11h00", value: "8" },
  { tsType: "3", label: "08h15 - 11h15", value: "8.25" },
  { tsType: "3", label: "08h30 - 11h30", value: "8.5" },
  { tsType: "3", label: "08h45 - 11h45", value: "8.75" },
  { tsType: "3", label: "09h00 - 12h00", value: "9" },
  { tsType: "3", label: "09h15 - 12h15", value: "9.25" },
  { tsType: "3", label: "09h30 - 12h30", value: "9.5" },
  { tsType: "3", label: "09h45 - 12h45", value: "9.75" },
  { tsType: "3", label: "10h00 - 13h00", value: "10" },
  { tsType: "3", label: "10h15 - 13h15", value: "10.25" },
  { tsType: "3", label: "10h30 - 13h30", value: "10.5" },
  { tsType: "3", label: "10h45 - 13h45", value: "10.75" },
  { tsType: "3", label: "14h00 - 17h00", value: "14" },
  { tsType: "3", label: "14h15 - 17h15", value: "14.25" },
  { tsType: "3", label: "14h30 - 17h30", value: "14.5" },
  { tsType: "3", label: "14h45 - 17h45", value: "14.75" },
  { tsType: "3", label: "15h00 - 18h00", value: "15" }
]

export const allPickupTimeOptions = [
  { label: "07h",  value:  "7" },
  { label: "07h15",  value:  "7.25" },
  { label: "07h30",  value:  "7.50" },
  { label: "07h45",  value:  "7.75" },
  { label: "08h",  value:  "8" },
  { label: "08h15",  value:  "8.25" },
  { label: "08h30",  value:  "8.50" },
  { label: "08h45",  value:  "8.75" },
  { label: "09h",  value:  "9" },
  { label: "09h15",  value:  "9.25" },
  { label: "09h30",  value:  "9.50" },
  { label: "09h45",  value:  "9.75" },
  { label: "10h",  value: "10" },
  { label: "10h15",  value: "10.25" },
  { label: "10h30",  value: "10.50" },
  { label: "10h45",  value: "10.75" },
  { label: "11h",  value: "11" },
  { label: "11h15",  value: "11.25" },
  { label: "11h30",  value: "11.50" },
  { label: "11h45",  value: "11.75" },
  { label: "12h",  value: "12" },
  { label: "12h15",  value: "12.25" },
  { label: "12h30",  value: "12.50" },
  { label: "12h45",  value: "12.75" },
  { label: "13h",  value: "13" },
  { label: "13h15",  value: "13.25" },
  { label: "13h30",  value: "13.50" },
  { label: "13h45",  value: "13.75" },
  { label: "14h",  value: "14" },
  { label: "14h15",  value: "14.25" },
  { label: "14h30",  value: "14.50" },
  { label: "14h45",  value: "14.75" },
  { label: "15h",  value: "15" },
  { label: "15h15",  value: "15.25" },
  { label: "15h30",  value: "15.50" },
  { label: "15h45",  value: "15.75" },
  { label: "16h",  value: "16" },
  { label: "16h15",  value: "16.25" },
  { label: "16h30",  value: "16.50" },
  { label: "16h45",  value: "16.75" },
  { label: "17h",  value: "17" },
  { label: "17h15",  value: "17.25" },
  { label: "17h30",  value: "17.50" },
  { label: "17h45",  value: "17.75" },
]

// Options for Tour Mode time selection
export const tourHourOptions = [
  { label: '09h', value: 9 }, { label: '10h', value: 10 }, { label: '11h', value: 11 },
  { label: '14h', value: 14 }, { label: '15h', value: 15 }, { label: '16h', value: 16 }, { label: '17h', value: 17 },
];
export const tourMinuteOptions = [
  { label: '00', value: 0 }, { label: '05', value: 5 }, { label: '10', value: 10 }, { label: '15', value: 15 },
  { label: '20', value: 20 }, { label: '25', value: 25 }, { label: '30', value: 30 }, { label: '35', value: 35 },
  { label: '40', value: 40 }, { label: '45', value: 45 }, { label: '50', value: 50 }, { label: '55', value: 55 },
];